
import FinanceSlider from "@/components/FinanceSlider/FinanceSlider";

interface FinanceSearchPanelProps {
  [key: string]: any;
}

export default function FinanceSearch( props: FinanceSearchPanelProps) {




    return (
        <>
        <div className="l-node-frontpage__block-small finance">

            <div className="block-inner">
                <div className="block-header">
                    <h2>{props['finance-search-header']}</h2>
                    <p>{props['finance-text']}</p>
                      {/* <h2><span>Explore the finance </span><span>options we have for you</span></h2>
                      <p>Easily narrow down your choices with our useful budget search</p> */}
                  </div>
                  <div className="block-form">
                        <FinanceSlider />
                  </div>
            </div>
        </div>
        </>
    );
}